import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalized,
} from "vue-router";
import { routes } from "./routes";

import { authGuard } from "./auth-guard";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach(authGuard);
router.beforeResolve(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    try {
      for (const route of to.matched) {
        await new Promise<void>((resolve, reject) => {
          // If a `beforeResolve` hook is defined, call it with
          // the same arguments as the `beforeEnter` hook.
          if (route.meta && route.meta.beforeResolve) {
            (route.meta as any).beforeResolve(to, from, (...args: any) => {
              // If the user chose to redirect...
              if (args.length) {
                // If redirecting to the same route we're coming from...
                // Complete the redirect.

                next([...args] as any);
                reject(new Error("Redirected"));
              } else {
                resolve();
              }
            });
          } else {
            // Otherwise, continue resolving the route.
            resolve();
          }
        });
      }
      // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
      return;
    }

    document.title = `${to.meta.title ? to.meta.title + " | " : ""} ${
      import.meta.env.VITE_APP_TITLE || "Axis Hub"
    }`;

    next();
  }
);

export default router;
